module.exports = __webpack_public_path__ + "img/vertical_7_6_3009.702677ed.png";